// 组件库公共样式
// import 'antd/dist/antd.css';
// import '@/pages/home/assets/scss/rewiteAnt/index.css';
import 'tea-component/dist/tea.css';
import '@/pages/home/assets/css/tokens/token-variables.css';
import '@/pages/home/assets/teaStyle/umi.css';

import {
  SYSTEM_THEME_KEY,
  SYSTEM_THEME_DARK,
  SYSTEM_THEME_DARK_CLASS,
} from '@home/_config/config';
import { useTag } from '@home/plugin/useTag';

// eslint-disable-next-line react-hooks/rules-of-hooks
useTag();

const theme = localStorage.getItem(SYSTEM_THEME_KEY);
if (theme === SYSTEM_THEME_DARK) {
  document.body.classList.add(SYSTEM_THEME_DARK_CLASS);
}

export const dva = {
  config: {
    onError(e: any) {
      e.preventDefault();
      console.error(e.message);
    },
  },
};
